import PrimeVue from 'primevue/config';
import KDM from "./kdm/KDM.vue";
import {createApp} from "vue";
import ConfirmationService from 'primevue/confirmationservice';

import { createI18n } from 'vue-i18n'
import { messages } from './i18n';
import {eplanete} from "@/eplanete";

const i18n = createI18n({
  legacy: false,
  locale: document.documentElement.getAttribute('lang') as string,
  messages,
})

createApp(KDM)
  .use(PrimeVue,{
    theme: {
      preset: eplanete
    }
  })
  .use(i18n)
  .use(ConfirmationService)
  .mount("#vue-kdm");
  console.log('KDM APP MOUNTED');
